module.exports = __webpack_public_path__ + "img/pdf.3dedc928.svg";